<a id="noticationNumber" class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" role="button"
    aria-haspopup="false" aria-expanded="false">
    <img src="assets/icons/notifications_black_24dp.svg">
    <span *ngIf="noticationNumber != 0 "
        class="badge rounded-pill badge-notification bg-danger">{{noticationNumber}}</span>
</a>

<div class="notification-list">

    <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated arrow-none">
        <span class="float-end">
            <a href="javascript: void(0);" class="text-dark" style="display:none">
                <small>Clear All</small>
            </a>
        </span>

        <!-- title -->
        <div class="dropdown-header">
            <h6 class="text-overflow m-0">{{'Notification'| translate}}</h6>
        </div>

        <div *ngFor="let Notifi of AllNotifi">
            <a class="dropdown-item" (click)="GoToScreen('',Notifi.routeTo)">
                <div class="notify-icon">
                    <img [src]="this.NotificationOptionMap.get(Notifi.screenName).Icon" alt="">
                </div>
                <span class="notify-details">
                    {{translateService.instant(Notifi.screenName)}}
                    <small class="badge bg-secondary">{{Notifi.notCount}}</small>
                </span>
            </a>
        </div>

    </div>
</div>